module.exports = __webpack_public_path__ + "img/1+pachet.f86fef14.png";